module.exports = __webpack_public_path__ + "static/media/pasamosagosto4.b146c610.webp";